var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.588,
    height: 41,
    viewBox: "0 0 39.588 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1181",
    "data-name": "Gruppe 1181",
    transform: "translate(-640.412 -59)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Checked_Pfd_RECOMMENDATIONS .cls-2 {\n        fill: #fff;\n      }\n\n      #Checked_Pfd_RECOMMENDATIONS .cls-1 {\n        fill: #3e4346;\n      }\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "Checked_Pfd_RECOMMENDATIONS",
    transform: "translate(-60 -0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-2",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(701 63)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_82",
    "data-name": "Gruppe 82",
    transform: "translate(701 63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_166",
    "data-name": "Pfad 166",
    className: "cls-1",
    d: "M18,0a12.75,12.75,0,0,0-2,.1A18.65,18.65,0,0,0,9,2.4,18.005,18.005,0,1,0,33.1,27.8a19.259,19.259,0,0,0,2.7-7A24.583,24.583,0,0,0,36,18,18.053,18.053,0,0,0,18,0ZM30.7,27.8A16.035,16.035,0,0,1,2,18,16.019,16.019,0,0,1,9,4.8a16.54,16.54,0,0,1,7-2.7A12.75,12.75,0,0,1,18,2,16.047,16.047,0,0,1,34,18a26.352,26.352,0,0,1-.2,2.8A18.353,18.353,0,0,1,30.7,27.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_79",
    "data-name": "Gruppe 79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_40",
    "data-name": "Rechteck 40",
    className: "cls-1",
    width: 12.3,
    height: 3,
    transform: "translate(14.8 10.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_41",
    "data-name": "Rechteck 41",
    className: "cls-1",
    width: 3,
    height: 3,
    transform: "translate(9.1 10.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_80",
    "data-name": "Gruppe 80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_42",
    "data-name": "Rechteck 42",
    className: "cls-1",
    width: 12.3,
    height: 3,
    transform: "translate(14.8 16.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_43",
    "data-name": "Rechteck 43",
    className: "cls-1",
    width: 3,
    height: 3,
    transform: "translate(9.1 16.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_81",
    "data-name": "Gruppe 81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_44",
    "data-name": "Rechteck 44",
    className: "cls-1",
    width: 12.3,
    height: 3,
    transform: "translate(14.8 21.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_45",
    "data-name": "Rechteck 45",
    className: "cls-1",
    width: 3,
    height: 3,
    transform: "translate(9.1 21.6)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1180",
    "data-name": "Gruppe 1180"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(662 59)",
    fill: "#00c4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DVS_Check",
    transform: "translate(-497.939 -288.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_569",
    "data-name": "Pfad 569",
    d: "M1170.694,362.662a4.7,4.7,0,1,1,4.7-4.7A4.709,4.709,0,0,1,1170.694,362.662Zm0-8.735a4.032,4.032,0,1,0,4.032,4.032A4.037,4.037,0,0,0,1170.694,353.926Z",
    transform: "translate(-2.494 -2.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_570",
    "data-name": "Pfad 570",
    d: "M1187.067,375.445a.669.669,0,0,1-.475-.2l-2.221-2.22a.671.671,0,0,1,.949-.949l2.221,2.22a.671.671,0,0,1-.474,1.146Z",
    transform: "translate(-13.221 -13.606)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCheck);
export default __webpack_public_path__ + "static/media/Plan_Check.8c63c94aa5d2053b790146ded282b929.svg";
export { ForwardRef as ReactComponent };